import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { Header } from "./components/header";
import { useLocation } from "react-router-dom";
import { OBJ_COLOR } from "commons/constants";

const Wrapper = styled.div`
	min-height: 100vh;
	padding: 35px;
	@media (max-width: 750px) {
		padding: 24px 12px;
	}
`;

export const Layout = (): JSX.Element => {
	const location = useLocation();

	return (
		<>
			{location.pathname.indexOf("/admin") > -1 && <Header />}
			<Wrapper style={{ background: location.pathname.indexOf("/admin") > -1 ? "" : OBJ_COLOR.SUCCESS_LIGHT }}>
				<Outlet />
			</Wrapper>
		</>
	);
};
